
import { SystemPriority, SystemPriorityName } from '../entities/shared/system.priority';
import { Priority } from '../entities/tenant/priority';
import { ColorUtility } from './color.utility';

export interface HasSystemPriority {
    systemPriority?: SystemPriority;
}

export class PriorityUtility {

    public static getColor(priority: HasSystemPriority): string {
        if (!priority) return 'transparent';
        return this.getSystemColor(priority.systemPriority);
    }

    public static getSystemColor(systemPriority: SystemPriority): string {
        if (!systemPriority) return 'transparent';

        switch (systemPriority) {
            case SystemPriority.P1:
                return '#ec3324';

            case SystemPriority.P2:
                return '#f29d39';

            case SystemPriority.P3:
                return '#fffe55';

            case SystemPriority.P4:
                return '#347ff7';

            case SystemPriority.P5:
                return '#58c43a';

        }
    }

    public static getSystemColorByName(systemPriority: SystemPriorityName): string {
        if (!systemPriority) return 'transparent';

        switch (systemPriority) {
            case SystemPriorityName.Urgent:
                return '#ec3324';

            case SystemPriorityName.High:
                return '#f29d39';

            case SystemPriorityName.Medium:
                return '#fffe55';

            case SystemPriorityName.Low:
                return '#347ff7';

            case SystemPriorityName.VeryLow:
                return '#58c43a';

        }
    }

    public static getTextColor(priority: Priority): string {
        const color = this.getColor(priority);
        return ColorUtility.idealTextColor(color);
    }

    public static getSortOrder(priority: HasSystemPriority): number {
        if (!priority) return 100000;

        const fullPriority = priority as Priority;

        const systemSortOrder = this.getSystemSortOrder(priority.systemPriority);
        const priorityOrder = fullPriority.sortOrder && !isNaN(fullPriority.sortOrder)
            ? fullPriority.sortOrder
            : 0;

        return systemSortOrder + priorityOrder;
    }

    public static getSystemSortOrder(systemPriority: SystemPriority): number {
        if (!systemPriority) return 100000;

        switch (systemPriority) {
            case SystemPriority.P1:
                return 1000;

            case SystemPriority.P2:
                return 2000;

            case SystemPriority.P3:
                return 3000;

            case SystemPriority.P4:
                return 4000;

            case SystemPriority.P5:
                return 5000;

        }
    }

    public static getAll(): SystemPriority[] {
        return [
            SystemPriority.P1,
            SystemPriority.P2,
            SystemPriority.P3,
            SystemPriority.P4,
            SystemPriority.P5
        ];
    }
}
